import { injectable, inject } from 'inversify';
import type { IPanelPagoRepository, PanelPagoFilters } from '@/domain/repositories/IPanelPagoRepository';
import { PanelPago } from '@/domain/entities/PanelPago';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListPanelPagosAction {
  constructor(
    @inject(TYPES.IPanelPagoRepository) private panelPagoRepository: IPanelPagoRepository
  ) {}

  async execute(filters?: PanelPagoFilters): Promise<PanelPago[]> {
    return await this.panelPagoRepository.getAll(filters);
  }
}
